import { Box, Grid, List, ListItem, MenuItem, Typography } from '@mui/material'
import _ from 'lodash'
import { useCallback, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** COMPONENT */
import { swalCustom } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import InputTextarea from 'component/Input/InputTextarea'
import BasicSelect from 'component/Select/BasicSelect'
import Info from 'features/finance/payment/component/popupPayment/Info'


import { notiError, notiSuccess } from 'component/notifications/notifications'
import PaymentChannels from 'features/finance/payment/component/popupPayment/PaymentChannels'
import SummaryReceipt from 'features/finance/payment/component/popupPayment/SummaryReceipt'


/** API */
import { PaymentInterface } from 'api/counter/payment/payment-interface'
import PaymentApi from 'api/counter/payment/payment.api'
import RegisterApi from 'api/counter/register.api'
import ClinicApi from 'api/master/clinic.api'
import PaymentChannelsApi from 'api/setting/finances/payment-channels.api'

/** CONSTANTS */
import { colors } from 'constants/theme'

/** UTILS || SLICE */
import {
  orderPaymentChannels,
  promotion,
  resetPaymentChannelByKey,
  resetStatePayment,
  setPaymentByKey,
  setSummery,
  setSummeryByKey,
  setSummerySubByKey,
  setSummerySubTreatmentRightByKey,
  summery,
  summerySub,
  summerySubTreatmentRight,
  summeryTreatmentRight,
  valBankCredit,
  valBankDebit,
  valBankTransfer,
  valPayment,
  voucher
} from 'app/slice/payment.slice'
import { setConcurrencyToken, TreatmentStateInterface, treatment } from 'app/slice/treatment.slice'
import { getBranch, getClinicInfo, getCrm, getMember, numberFormat, numberToCurrencyFormat } from 'utils/app.utils'

/** STYLE */
import CancelIcon from '@mui/icons-material/Cancel'
import { fileUrl } from 'api/api'
import TreatmentSummaryApi from 'api/dentists/treatment-summary.api'
import OverdueApi from 'api/finances/overdue.api'
import PromotionsApi from 'api/promotion/promotion.api'
import PatientTypeApi from 'api/setting/default-users/patient-type.api'
import VoucherApi from 'api/voucher/voucher.api'
import Loading from 'component/Loading'
import { Config } from 'config'
import * as UseStyled from 'features/finance/payment/component/popupPayment/UseStyledFormPayment'
import AlertModal from 'new-components/modal/alert-modal'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'
import { dateTimeToView } from 'utils/date.utils'

type ModalCustomProps = {
  type: 'PAYMENT' | 'OVERDUE' | 'RETROSPECTIVE' | 'EDIT_PAYMENT'
  isShow: boolean | false
  patient: any
  detail?: any
  histories?: any[]
  orderPaymentId?: number
  initBalance?: any
  setIsShow: (show: boolean) => void
  onSuccess?: (val?: any) => void
  date?: any
  patientCaseId?: any
  dataPatientCase?: any
}

export interface PatientFinanceInterface {
  advanceBalance: number
  outstandingBalance: number
  treatmentRights: any[]
}

export default function PopupPayment(props: ModalCustomProps) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [disabledButton, setDisabledButton] = useState<boolean>(false)
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const objPayment: PaymentInterface = useSelector(valPayment)
  const valSummery = useSelector(summery)
  const valSummerySub = useSelector(summerySub)
  const valSummeryTreatmentRight = useSelector(summeryTreatmentRight)
  const valSummerySubTreatmentRight = useSelector(summerySubTreatmentRight)
  const bankCredit: any = useSelector(valBankCredit)
  const bankTransfer: any = useSelector(valBankTransfer)
  const bankDebit: any = useSelector(valBankDebit)
  const paymentChannelsSelected: any = useSelector(orderPaymentChannels)
  const usePromotion = useSelector(promotion)
  const useVoucher = useSelector(voucher)
  const branchId = getBranch()
  const [activePage, setActivePage] = useState(0)
  const [patientFinance, setPatientFinance] = useState<PatientFinanceInterface>({ advanceBalance: 0, outstandingBalance: 0, treatmentRights: [] })
  const [banks, setBanks] = useState<any[]>([])
  const [billPrefixes, setBillPrefixes] = useState([])
  const [defaultPaymentChannels, setDefaultPaymentChannels] = useState([])
  const [editAdvance, setEditAdvance] = useState<number>(props.detail?.orderPaymentChannelAdvance || 0)
  const [editTreatmentRight, setEditTreatmentRight] = useState<number>(props.detail?.orderPaymentChannelTreatmentRight || 0)
  const [editAmountReceipt, setEditAmountReceipt] = useState<number>(props.detail?.orderPaymentChannel || 0)
  const arrNoPc = [0, 5, 6, 1, 2, 3, 4, 7, 8, 10]
  const arrChanel = [0, 1, 2, 3, 4, 5, 6, 7, 8, 10]
  const [allItem, setAllItem] = useState<any>([])
  const [overdueCal, setOverdueCal] = useState<number>(0)
  const [treatmentRight, setTreatmentRight] = useState<boolean>(false)
  const [disabledNext, setDisabledNext] = useState<boolean>(false)
  const [autoIncrement, setAutoIncrement] = useState('')
  const [currentRank, setCurrentRank] = useState<any>({})
  const [newRank, setNewRank] = useState<any>({})
  const [isDupicate, setIsDupicate] = useState(false)
  const memberAll = getMember()
  const [promotionPayment, setPromotionPayment] = useState<any>([])
  const [voucherPayment, setVoucherPayment] = useState<any>({})

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [dataUrl, setDataUrl] = useState(null)
  const [checkType, setCheckType] = useState<any>([])
  const [objectData, setObjectData] = useState<any>(null)

  const [isNhsoSaveMedicalModal, setIsNhsoSaveMedicalModal] = useState(false)
  const [isCheckErrorNhsoModal, setiIsCheckErrorNhsoModal] = useState(false)
  const [checkDataError, setCheckDataError] = useState<any>([])

  const history = useHistory()
  const priceOutStanding = treatments?.outStandingPayment?.overdueTotal || 0


  useEffect(() => {

    setAllItem([])
    if (props.detail && props.type === "EDIT_PAYMENT") {
      _.map(props.detail.order?.orderTreatments, (item: any) => {
        allItem.push(item)
      })
      _.map(props.detail.order?.orderProducts, (item: any) => {
        allItem.push(item)
      })
    }
  }, [props.detail])

  const loadData = useCallback(() => {
    if (props.isShow) {
      setLoading(true)
      dispatch(resetPaymentChannelByKey())

      const data = getClinicInfo()
      setAutoIncrement(data.autoIncrement)

      // props.patient?.patientId || props.patient.order?.patientId
      RegisterApi.findPatientFinanceByPatientId(props.patient?.patientId).then((resPatientFinance: any) => {
        if (resPatientFinance.status === 200) {
          const treatmentRights = resPatientFinance.data.patientTreatmentRights
          let num = 0;
          treatmentRights.map((e: any) => { num += e.balance })
          num === 0 ? setTreatmentRight(true) : setTreatmentRight(false)
          let advanceBalance = parseFloat(resPatientFinance.data.advanceBalance)
          if (props?.detail?.orderPaymentChannels) {
            for (const paymentChannel of props.detail.orderPaymentChannels) {
              if (paymentChannel.paymentChannelId === 5) {
                const treatmentRight = _.find(treatmentRights, { treatmentRightId: parseInt(paymentChannel.treatmentRightId) })
                const treatmentRightIndex = _.findIndex(treatmentRights, { treatmentRightId: parseInt(paymentChannel.treatmentRightId) })
                if (treatmentRight) {
                  if (treatmentRight.isDivide === '0') {
                    treatmentRight.balance = treatmentRight.balance + 1
                    treatmentRight.amountUsed = treatmentRight.amountUsed - 1
                  }
                  else {
                    treatmentRight.balance = treatmentRight.balance + paymentChannel.amountPaid
                    treatmentRight.amountUsed = treatmentRight.amountUsed - paymentChannel.amountPaid
                  }
                  treatmentRight.amountPaid = paymentChannel.amountPaid
                  treatmentRights[treatmentRightIndex] = treatmentRight
                }
              }
              if (paymentChannel.paymentChannelId === 6) {
                advanceBalance += parseFloat(paymentChannel.amountPaid)
              }
            }
          }
          setPatientFinance({ advanceBalance: advanceBalance, outstandingBalance: resPatientFinance.data.outstandingBalance, treatmentRights: treatmentRights })
        }
      })

      if (getCrm()) {
        if (props?.detail) {
          const promotionOp = props?.detail?.orderPaymentChannels?.find((item: any) => item?.paymentChannelId === 8 && item?.amountPaid > 0)
          const voucherOp = props?.detail?.orderPaymentChannels?.find((item: any) => item?.paymentChannelId === 7 && item?.amountPaid > 0)
          if (promotionOp?.amountPaid) {
            setPromotionPayment((pev: any) => [{
              promotionName: `${promotionOp?.promotionName || ''}`,
              promotionBranchId: promotionOp?.promotionBranchId,
              promotionId: promotionOp?.promotionId,
              detail: promotionOp?.promotionDetail || ''
            }])
          }
          if (voucherOp?.amountPaid) {
            setVoucherPayment((pev: any) => [{
              voucherCode: voucherOp?.voucherCode || '',
              voucherName: `${voucherOp?.voucherName}`,
              voucherListId: voucherOp?.voucherListId,
              voucherId: voucherOp?.voucherId || 999,
              detail: voucherOp?.voucherDetail || ''
            }])
          }
        } else {
          if (props.type === "RETROSPECTIVE") {
            PromotionsApi.findPromotionTreatments({
              branchId: branchId,
              patientId: props.patient?.patientId,
              items: _.map(treatments.summeryTreatments, (item) => ({ itemType: item.group || 'OPERATIVE', itemId: item.operativeId || item.itemId, qty: item.qty })),
              totalPrice: _.sumBy(treatments.summeryTreatments, 'total'),
              date: props.date,
              isPayment: '1'
            }).then((resp) => {
              setPromotionPayment(resp.data?.promotions)
              setVoucherPayment(resp.data?.vouchers)
            })
          } else {
            PromotionsApi.findPromotionPayment(props.patientCaseId ? props.patientCaseId : props?.patient?.patientCase?.patientCaseId || props?.detail?.order?.patientCaseId).then((res) => {
              const newData = res?.data?.filter((item: any) => item?.type !== "EXTRA") || []
              setPromotionPayment(newData)
            })
            // props?.patient?.patientCase?.patientCaseId || props?.detail?.order?.patientCaseId
            VoucherApi.findVoucherPatientAll(props.patientCaseId ? props.patientCaseId : props?.patient?.patientCase?.patientCaseId || props?.detail?.order?.patientCaseId).then((res) => {
              setVoucherPayment(res.data)
            })
          }

        }
      }

      ClinicApi.findAllBanks(branchId).then((resBanks) => {
        if (resBanks.status === 200) setBanks(resBanks.data.sort((a: any, b: any) => a.bankId - b.bankId))
      })

      ClinicApi.allBillPrefix().then((resBillPrefixes) => {
        setBillPrefixes(resBillPrefixes.data)
        dispatch(setPaymentByKey({ key: 'prefix', value: resBillPrefixes?.data[0].prefix || '' }))
      })
      PaymentChannelsApi.findAll({}).then((resp) => setDefaultPaymentChannels(resp.data))

      dispatch(setSummery({}))
      let initBalance: any = 0
      if (!_.isEmpty(props?.initBalance)) {
        initBalance = Object.values(props?.initBalance).reduce((a: any, b: any) => Number(a || 0) + Number(b || 0))
        dispatch(setSummeryByKey({ key: 0, value: initBalance }))

      }
      const isEditPayment = props.type === 'EDIT_PAYMENT' ? true : false
      const total = _.sumBy(treatments.summeryTreatments, (treatment: any) => {
        if (treatment.installment) {
          const pendingInstallment = _.find(treatment.installment.installmentList, { status: "PENDING" });
          if (pendingInstallment) {
            return pendingInstallment.price;
          }
        }
        return treatment.total;
      });

      let voucherPromotion = 0
      if (props.detail?.orderPaymentChannels) {
        _.map(props.detail?.orderPaymentChannels, (v) => {
          if (v.paymentChannelId === 7 || v.paymentChannelId === 8) {
            _.map(v.orderPaymentItems, (i) => {
              voucherPromotion += i.amountPaid
            })
          }
        })
      }

      dispatch(setPaymentByKey({ key: 'totalPrice', value: isEditPayment ? (props.detail.totalPrice + voucherPromotion) : total - Number(initBalance) - priceOutStanding }))

      for (const keyPcId of arrNoPc) {
        let newPriceOutStanding = priceOutStanding
        for (const index in isEditPayment ? allItem : treatments.summeryTreatments) {
          if (Object.prototype.hasOwnProperty.call(isEditPayment ? allItem : treatments.summeryTreatments, index)) {
            let summaryTreatment: any = isEditPayment ? allItem[index] : treatments.summeryTreatments[index];
            if (summaryTreatment.installment) {
              const pendingInstallment = _.find(summaryTreatment.installment.installmentList, { status: "PENDING" });
              if (pendingInstallment) {
                summaryTreatment = { ...summaryTreatment, total: pendingInstallment.price };
              }
            }
            let type = ''
            let id: any = null

            if (summaryTreatment.tempOrderTreatmentId || summaryTreatment.orderTreatmentId) id = summaryTreatment.tempOrderTreatmentId || summaryTreatment.orderTreatmentId
            else if (summaryTreatment.tempOrderProductId || summaryTreatment.orderProductId) id = summaryTreatment.tempOrderProductId || summaryTreatment.orderProductId
            else id = parseInt(index) + 1

            const isTreatment = summaryTreatment.tempOrderTreatmentId || summaryTreatment.orderTreatmentId || summaryTreatment.operativeId ? true : false
            if (props.type === 'RETROSPECTIVE') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
            else if (props.type === 'OVERDUE') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
            else if (props.type === 'EDIT_PAYMENT') type = isTreatment ? 'ORDER_TREATMENT' : 'ORDER_PRODUCT'
            else type = isTreatment ? 'TEMP_ORDER_TREATMENT' : 'TEMP_ORDER_PRODUCT'

            let pay = 0
            let payEdit = 0
            let newEdit = null

            if ((props?.type === 'OVERDUE' || isEditPayment) && props?.histories) {

              for (const his of props.histories) {
                pay += _.find(his.itemBalances, { refItemId: id, refItemType: type })?.paid || 0
              }
              // pay = _.sum(
              //   _.chain(props.histories)
              //     .map((his, id) => his?.itemPaids[type] ? (his?.itemPaids[type]?.[id] || 0) : 0)
              //     .value()
              // ) || 0

              if (isEditPayment) {
                newEdit = _.find(props.histories, { orderPaymentId: props?.detail?.orderPaymentId });
                if (newEdit) {
                  newEdit = _.find(newEdit.paidItems, { paymentChannelId: keyPcId })
                  if (newEdit) newEdit = _.find(newEdit.items, { refItemId: id, refItemType: type })
                  payEdit = newEdit?.amountPaid || 0

                }
              }
            }



            const newPriceOut = summaryTreatment.total < newPriceOutStanding ? summaryTreatment.total : newPriceOutStanding
            const newTotal = (summaryTreatment.total - newPriceOutStanding) <= 0 ? 0 : summaryTreatment.total - newPriceOutStanding
            newPriceOutStanding = (summaryTreatment.total - newPriceOutStanding) < 0 ? newPriceOutStanding - summaryTreatment.total : 0

            dispatch(setSummerySubByKey({ key: keyPcId, keySub: index, value: { isCheck: newEdit && isEditPayment ? true : false, value: payEdit, treatmentPrice: newTotal, paidBalance: newTotal - (pay || 0), type: type, id: id, isDisabled: true, paymentOut: newPriceOut } }))
            // dispatch(setSummerySubByKey({ key: keyPcId, keySub: index, value: { isCheck: false, value: 0, treatmentPrice: summaryTreatment.total, type: type, id: id, paidBalance: newTotal - (pay || 0), isDisabled: true, paymentOut: newPriceOut } }))
          }
        }
      }
      setLoading(false)
    }
  }, [props.isShow, treatments])

  useEffect(() => {
    loadData()
  }, [loadData, props.isShow, treatments])


  useEffect(() => {
    let amountReceipt = Object.keys(valSummery).reduce((sum, key) => sum + parseFloat(parseInt(key) !== 5 && parseInt(key) !== 6 && parseInt(key) !== 7 && parseInt(key) !== 8 ? valSummery[key] : 0), 0) || editAmountReceipt || 0
    if (Object.keys(valSummery).reduce((sum, key) => sum + parseFloat(parseInt(key) !== 5 && parseInt(key) !== 6 && parseInt(key) !== 7 && parseInt(key) !== 8 ? valSummery[key] : 0), 0)) setEditAmountReceipt(0)

    if (props.type === 'EDIT_PAYMENT')
      amountReceipt = Object.keys(valSummery).reduce((sum, key) => sum + parseFloat(parseInt(key) !== 5 && parseInt(key) !== 6 && parseInt(key) !== 7 && parseInt(key) !== 8 ? valSummery[key] : 0), 0) || 0

    const totalPrice = objPayment.totalPrice

    let discountTreatmentRight = _.sumBy(valSummeryTreatmentRight[5], (o: any) => { return o?.isCheck ? Number(o.value) : 0 }) || 0
    /** Fix Case isNhso  */
    if (props.dataPatientCase?.isNhso === '1' && paymentChannelsSelected[5]) discountTreatmentRight = 700

    const discountPromotion = _.sumBy(valSummeryTreatmentRight[8], (o: any) => { return o?.isCheck ? Number(o.value) : 0 }) || 0
    const discountVoucher = _.sumBy(valSummeryTreatmentRight[7], (o: any) => { return o?.isCheck ? Number(o.value) : 0 }) || 0

    const advance = valSummery[6] || editAdvance || 0
    if (valSummery[6]) setEditAdvance(0)

    const subTotal = totalPrice - discountTreatmentRight - advance - discountPromotion - discountVoucher

    let amountChange = amountReceipt - subTotal
    let overdue = subTotal - amountReceipt
    setOverdueCal(overdue)
    if (amountChange < 0) amountChange = 0
    if (overdue < 0) overdue = 0

    dispatch(setPaymentByKey({ key: 'discountTreatmentRight', value: discountTreatmentRight }))
    dispatch(setPaymentByKey({ key: 'advance', value: advance }))
    dispatch(setPaymentByKey({ key: 'subTotal', value: subTotal }))
    dispatch(setPaymentByKey({ key: 'amountReceipt', value: amountReceipt }))
    dispatch(setPaymentByKey({ key: 'amountChange', value: amountChange }))
    dispatch(setPaymentByKey({ key: 'overdue', value: overdue }))
    dispatch(setPaymentByKey({ key: 'discountPromotion', value: discountPromotion }))
    dispatch(setPaymentByKey({ key: 'discountVoucher', value: discountVoucher }))
  }, [valSummery, valSummerySub, valSummeryTreatmentRight, valSummerySubTreatmentRight])


  const payment = async () => {
    if (_.every(paymentChannelsSelected, (v: any) => v === false)) return notiError(t('PAYMENT.FORM.PLS_SELECT_PAYMENT_CHANNEL'), undefined, undefined, () => {
      setDisabledButton(false)
      setDisabledNext(false)
    })
    else if (overdueCal === 0 && treatmentRight && paymentChannelsSelected[5] && props.type !== 'EDIT_PAYMENT' && props.dataPatientCase?.isNhso !== '1') return notiError(t('PAYMENT.MESSAGE.SUCCESS.CHANGE_PAYMENT_METHOD'), undefined, undefined, () => {
      setDisabledButton(false)
      setDisabledNext(false)
    })
    else if (overdueCal + priceOutStanding > 0 && props.type !== 'EDIT_PAYMENT') {
      const optionButton = {
        confirmButton: {
          confirmButtonText: t('PAYMENT.FORM_PAYMENT.OVERDUE_CONFIRM.YES')
        },
        cancelButton: {
          cancelButtonText: t('PAYMENT.FORM_PAYMENT.OVERDUE_CONFIRM.NO'),
          showCancelButton: true
        },
      }
      swalCustom(
        t('PAYMENT.FORM_PAYMENT.OVERDUE_CONFIRM.TITLE'),
        t('PAYMENT.FORM_PAYMENT.OVERDUE_CONFIRM.CAPTION'), (res: any) => {
          if (res) {
            setDisabledButton(true)
            setDisabledNext(true)
            if (_.every(paymentChannelsSelected, (v: any) => v === false)) return notiError(t('PAYMENT.FORM.PLS_SELECT_PAYMENT_CHANNEL'), undefined, undefined, () => {
              setDisabledButton(false)
              setDisabledNext(false)
            })
            else handelCheckRank()
          } else {
            setDisabledButton(false)
            setDisabledNext(false)
          }
        },
        'question',
        optionButton
      )
    } else handelCheckRank()
  }

  const alertTreantRights = async () => {
    if (_.every(paymentChannelsSelected, (v: any) => v === false)) return notiError(t('PAYMENT.FORM.PLS_SELECT_PAYMENT_CHANNEL'), undefined, undefined, () => {
      setDisabledButton(false)
      setDisabledNext(false)
    })
    else setActivePage(1)
  }

  const finishPayment = async () => {
    const newOrderPaymentChannels: any = []
    const objPay = {
      prefix: objPayment.prefix,
      totalPrice: (objPayment.totalPrice + priceOutStanding),
      amountPaid: objPayment.amountPaid,
      amountReceipt: objPayment.amountReceipt,
      amountChange: objPayment.amountChange,
      overdue: (objPayment.overdue + priceOutStanding),
      remark: objPayment.remark,
      orderPaymentChannels: newOrderPaymentChannels
    }
    if (props.type === 'EDIT_PAYMENT' ? !allItem : !treatments.summeryTreatments.length) return notiError(t('TREATMENT_SUMMARY.MESSAGE.PLS_SELECT_TREATMENT'), undefined, undefined, () => { setDisabledButton(false) })
    // if (props.type === 'EDIT_PAYMENT' && summaryValue() !== summaryOriginalValue()) return notiError(`${t('PAYMENT.MESSAGE.ERROR.PAY_ORIGINAL_VALUE')} ${numberFormat(summaryOriginalValue())} ${t('CURRENCY_CHANGE.TH')}`)
    /** CASH */
    if (paymentChannelsSelected[1]) {
      const paymentChannelId = 1
      const orderPaymentItems: any = []
      const payWithCash = valSummerySub[paymentChannelId] || {}
      let amountPaid = 0
      let checkSelect = paymentChannelsSelected[1] || false
      if (!_.isEmpty(payWithCash)) {
        _.map(payWithCash, (i: any, index: number) => {
          if (newOrderPaymentChannels?.length !== 0) {
            if (i.isCheck) {
              orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
              amountPaid += i.value
              checkSelect = true
            }
          } else if (i.isCheck || i.treatmentPrice === 0) {
            orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
            amountPaid += i.value
            checkSelect = true
          }
          // if (i.value >= 0 && i.value !== undefined) {
          //   orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
          //   amountPaid += i.value
          //   checkSelect = true
          // }
        })
      }
      if (checkSelect) newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: '', cardTypeId: '', patientTreatmentRightId: '', orderPaymentItems: orderPaymentItems })
    }
    /** TRANSFER */
    if (paymentChannelsSelected[2]) {
      if (!bankTransfer?.bankId) return notiError(t('PAYMENT.FORM.PLS_SELECT_BANK'), undefined, undefined, () => { setDisabledButton(false) })
      const paymentChannelId = 2
      const orderPaymentItems: any = []
      let amountPaid = 0
      let checkSelect = paymentChannelsSelected[2] || false
      const payWithTransfer = valSummerySub[paymentChannelId] || null
      if (!_.isEmpty(payWithTransfer)) {
        _.map(payWithTransfer, (i: any, index: number) => {
          if (newOrderPaymentChannels?.length !== 0) {
            if (i.isCheck) {
              orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
              amountPaid += i.value
              checkSelect = true
            }
          } else if (i.isCheck || i.treatmentPrice === 0) {
            orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
            amountPaid += i.value
            checkSelect = true
          }
          // if (i.value >= 0 && i.value !== undefined) {
          //   orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
          //   amountPaid += i.value
          //   checkSelect = true
          // }
        })
      }
      if (checkSelect) newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: bankTransfer.bankId, cardTypeId: '', patientTreatmentRightId: '', orderPaymentItems: orderPaymentItems })
    }
    /** CREDIT */
    if (paymentChannelsSelected[3]) {
      if (!bankCredit?.bankId) return notiError(t('PAYMENT.FORM.PLS_SELECT_BANK'), undefined, undefined, () => { setDisabledButton(false) })
      if (!bankCredit?.cardTypeId) return notiError(t('PAYMENT.FORM.PLS_SELECT_CARD_TYPE'), undefined, undefined, () => { setDisabledButton(false) })
      const paymentChannelId = 3
      const orderPaymentItems: any = []
      let amountPaid = 0
      let checkSelect = paymentChannelsSelected[3] || false

      const payWithCredit = valSummerySub[paymentChannelId] || null
      if (!_.isEmpty(payWithCredit)) {
        _.map(payWithCredit, (i: any, index: number) => {
          if (newOrderPaymentChannels?.length !== 0) {
            if (i.isCheck) {
              orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
              amountPaid += i.value
              checkSelect = true
            }
          } else if (i.isCheck || i.treatmentPrice === 0) {
            orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
            amountPaid += i.value
            checkSelect = true
          }
          // if (i.value >= 0 && i.value !== undefined) {
          //   orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
          //   amountPaid += i.value
          //   checkSelect = true
          // }
        })
      }

      if (checkSelect)
        newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: bankCredit.bankId, cardTypeId: bankCredit.cardTypeId, patientTreatmentRightId: '', orderPaymentItems: orderPaymentItems })
    }
    /** DEBIT */
    if (paymentChannelsSelected[4]) {
      if (!bankDebit?.bankId) return notiError(t('PAYMENT.FORM.PLS_SELECT_BANK'), undefined, undefined, () => { setDisabledButton(false) })
      if (!bankDebit?.cardTypeId) return notiError(t('PAYMENT.FORM.PLS_SELECT_CARD_TYPE'), undefined, undefined, () => { setDisabledButton(false) })
      const paymentChannelId = 4
      const orderPaymentItems: any = []
      let amountPaid = 0
      let checkSelect = paymentChannelsSelected[4] || false
      const payWithDebit = valSummerySub[paymentChannelId] || null
      if (!_.isEmpty(payWithDebit)) {
        _.map(payWithDebit, (i: any, index: number) => {
          if (newOrderPaymentChannels?.length !== 0) {
            if (i.isCheck) {
              orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
              amountPaid += i.value
              checkSelect = true
            }
          } else if (i.isCheck || i.treatmentPrice === 0) {
            orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
            amountPaid += i.value
            checkSelect = true
          }
          // if (i.value >= 0 && i.value !== undefined) {
          //   orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : i.id, refItemType: i.type, amountPaid: i.value })
          //   amountPaid += i.value
          //   checkSelect = true
          // }
        })
      }
      if (checkSelect)
        newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: bankDebit.bankId, cardTypeId: bankDebit.cardTypeId, patientTreatmentRightId: '', orderPaymentItems: orderPaymentItems })
    }

    /** WALLET */
    if (paymentChannelsSelected[10]) {
      const paymentChannelId = 10
      const orderPaymentItems: any = []
      const payWithWallet = valSummerySub[paymentChannelId] || {}
      let amountPaid = 0
      let checkSelect = paymentChannelsSelected[10] || false
      if (!_.isEmpty(payWithWallet)) {

        _.map(payWithWallet, (i: any, index: number) => {
          if (i.value >= 0 && i.value !== undefined) {
            orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : Number(i.id), refItemType: i.type, amountPaid: i.value })
            amountPaid += i.value
            checkSelect = true
          }
        })
      }
      if (checkSelect) newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: '', cardTypeId: '', patientTreatmentRightId: '', orderPaymentItems: orderPaymentItems })
    }

    if (props.type === 'PAYMENT' || props.type === 'RETROSPECTIVE' || props.type === 'EDIT_PAYMENT' || props.type === 'OVERDUE') {
      /** TREATMENT_RIGHT */
      if (valSummeryTreatmentRight[5] && paymentChannelsSelected[5]) {
        const paymentChannelId = 5
        const payWithTreatmentRight = valSummeryTreatmentRight[paymentChannelId] || null
        if (!_.isEmpty(payWithTreatmentRight)) {

          // ปิดไว้เพราะมันจะส่งค่า orderPaymentItem ไปแค่ตามจำนวนที่ติ๊ก checkbox
          if (payWithTreatmentRight.some((item: any) => item?.isCheck)) {
            for (const index in payWithTreatmentRight) {
              if (payWithTreatmentRight[index].isCheck) {
                const payTreatmentRightSub = valSummerySubTreatmentRight[paymentChannelId][index] || null
                let amountPaid = 0
                let checkSelect = false
                const orderPaymentItems: any = []
                _.map(payTreatmentRightSub, (j: any, ind: number) => {
                  if (newOrderPaymentChannels.length !== 0) {
                    if (j.isCheck) {
                      orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? ind + 1 : j.id, refItemType: j.type, amountPaid: j.value })
                      amountPaid += j.value
                      checkSelect = true
                    }
                  } else if (j.isCheck || j.treatmentPrice === 0) {
                    orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? ind + 1 : j.id, refItemType: j.type, amountPaid: j.value })
                    amountPaid += j.value
                    checkSelect = true
                  }
                })
                newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: '', cardTypeId: '', patientTreatmentRightId: index, orderPaymentItems: orderPaymentItems })
              }
            }
          } else {
            const paymentChannelId = 5
            const orderPaymentItems: any = []
            const payWithCash = valSummerySub[paymentChannelId] || {}
            let amountPaid = 0
            let checkSelect = paymentChannelsSelected[5] || false
            if (!_.isEmpty(payWithCash)) {
              _.map(payWithCash, (i: any, index: number) => {
                if (i.value >= 0 && i.value !== undefined) {
                  orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : i.id, refItemType: i.type, amountPaid: i.value })
                  amountPaid += i.value
                  checkSelect = true
                }
              })
            }
            if (checkSelect) newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: '', cardTypeId: '', patientTreatmentRightId: '', orderPaymentItems: orderPaymentItems })
          }
        }
      }
    }



    if (valSummeryTreatmentRight[7] && paymentChannelsSelected[7]) {
      const paymentChannelId = 7
      const payWithTreatmentRight = valSummeryTreatmentRight[paymentChannelId] || null
      if (!_.isEmpty(payWithTreatmentRight)) {
        if (payWithTreatmentRight.some((item: any) => item?.isCheck)) {
          for (const index in payWithTreatmentRight) {
            if (payWithTreatmentRight[index].isCheck) {
              const payTreatmentRightSub = valSummerySubTreatmentRight[paymentChannelId][index] || null
              let amountPaid = 0
              let checkSelect = false
              const orderPaymentItems: any = []
              _.map(payTreatmentRightSub, (j: any, index: number) => {
                if (j.isCheck) {
                  orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : j.id, refItemType: j.type, amountPaid: j.value })
                  amountPaid += j.value
                  checkSelect = true
                }
              })

              newOrderPaymentChannels.push({
                paymentChannelId: paymentChannelId,
                amountPaid: amountPaid,
                voucherPaid: amountPaid,
                voucherListId: Number(index) || 0,
                bankId: '',
                cardTypeId: '',
                patientTreatmentRightId: index,
                orderPaymentItems: orderPaymentItems
              })
            }
          }
        }
      }
    }

    if (props.type === 'PAYMENT' || props.type === 'RETROSPECTIVE' || (props.type === 'EDIT_PAYMENT' && props.detail.stage === 1)) {

      treatments?.summeryTreatments?.forEach((item: any) => {
        if (item?.voucherListId && !newOrderPaymentChannels.some((info: any) => info?.voucherListId === item?.voucherListId)) {
          const paid = Number(item?.voucherDiscount || 0) + Number(item?.dfVoucherDiscountAmount || 0) + Number(item?.cfVoucherDiscountAmount || 0)


          // const newNormalPrice = item?.fullPrice
          // const rawVoucherPriceType = item?.voucher?.voucherPriceType || ""
          // const rawVoucherUsage = item?.voucher?.voucherUsage || ""
          // const rawVoucherDiscount = Number(item?.voucher?.voucherPrice || 0)
          // const rawVoucherDiscountUnit = item?.voucher?.voucherPriceUnit
          // /** ส่วนลด Voucher */
          // if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.PERCENT) paid = newNormalPrice * (rawVoucherDiscount / 100)
          // if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.BAHT) paid = rawVoucherDiscount
          // if (rawVoucherPriceType === 'SALEPRICE') paid = newNormalPrice - rawVoucherDiscount

          newOrderPaymentChannels?.push({
            paymentChannelId: 7,
            amountPaid: 0,
            voucherPaid: paid || 0,
            voucherListId: item?.voucherListId,
            bankId: '',
            cardTypeId: '',
            patientTreatmentRightId: item?.voucherListId,
            orderPaymentItems: []
          })
        }


      })
    }

    if (valSummeryTreatmentRight[8] && paymentChannelsSelected[8]) {
      const paymentChannelId = 8
      const payWithTreatmentRight = valSummeryTreatmentRight[paymentChannelId] || null
      if (!_.isEmpty(payWithTreatmentRight)) {
        if (payWithTreatmentRight.some((item: any) => item?.isCheck)) {
          for (const index in payWithTreatmentRight) {
            if (payWithTreatmentRight[index].isCheck) {
              const payTreatmentRightSub = valSummerySubTreatmentRight[paymentChannelId][index] || null
              let amountPaid = 0
              let checkSelect = false
              const orderPaymentItems: any = []
              _.map(payTreatmentRightSub, (j: any, index: number) => {
                if (j.isCheck) {
                  orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : j.id, refItemType: j.type, amountPaid: j.value })
                  amountPaid += j.value
                  checkSelect = true
                }
              })
              newOrderPaymentChannels.push({
                paymentChannelId: paymentChannelId,
                amountPaid: amountPaid,
                promotionPaid: amountPaid,
                promotionBranchId: Number(index),
                promotionId: promotionPayment?.find((item: any) => item?.promotionBranchId === Number(index))?.promotionId || 0,
                bankId: '',
                cardTypeId: '',
                patientTreatmentRightId: index,
                orderPaymentItems: orderPaymentItems
              })
            }
          }
        }
      }
    }

    if (props.type === 'PAYMENT' || props.type === 'RETROSPECTIVE' || (props.type === 'EDIT_PAYMENT' && props.detail.stage === 1)) {

      treatments?.summeryTreatments?.forEach((item: any) => {
        item?.promotion?.length && item?.promotion.forEach((i: any) => {
          if (i?.promotionBranchId && !newOrderPaymentChannels.some((info: any) => info?.promotionBranchId === i?.promotionBranchId)) {

            // const paid = item?.promotionDiscountUnit === 'PERCENT' ? (item?.fullPrice * item?.promotionDiscount) / 100 : item?.promotionDiscount
            const paid = Number(item?.promotionDiscount || 0) + Number(item?.dfPromotionDiscountAmount || 0) + Number(item?.cfPromotionDiscountAmount || 0)

            // let paid = 0
            // const newNormalPrice = item?.fullPrice
            // const rawPromotionType = i?.type || ""
            // const rawPromotionPriceType = i?.promotionPriceType || ""
            // const rawPromotionUsage = i?.promotionUsage || ""
            // const rawPromotionDiscount = Number(i?.promotionPrice || 0)
            // const rawPromotionDiscountUnit = i?.promotionPriceUnit || CURRENCY_UNIT.BAHT

            // /** ส่วนลด Promotion */
            // if (rawPromotionType === 'DISCOUNT' && rawPromotionPriceType === 'DISCOUNT' && rawPromotionDiscountUnit === CURRENCY_UNIT.PERCENT) paid = newNormalPrice * (rawPromotionDiscount / 100)
            // if (rawPromotionType === 'DISCOUNT' && rawPromotionPriceType === 'DISCOUNT' && rawPromotionDiscountUnit === CURRENCY_UNIT.BAHT) paid = rawPromotionDiscount
            // if (rawPromotionType === 'DISCOUNT' && rawPromotionPriceType === 'SALEPRICE') paid = newNormalPrice - rawPromotionDiscount


            newOrderPaymentChannels?.push({
              paymentChannelId: 8,
              amountPaid: 0,
              promotionPaid: i?.type === "EXTRA" ? 0 : paid || 0,
              promotionBranchId: i?.promotionBranchId,
              promotionId: i?.promotionId,
              bankId: '',
              cardTypeId: '',
              patientTreatmentRightId: i?.promotionBranchId,
              orderPaymentItems: []
            })
          }
        })
      })
    }
    /** ADVANCE */
    if (valSummerySub[6] && paymentChannelsSelected[6]) {
      const paymentChannelId = 6
      const orderPaymentItems: any = []
      let amountPaid = 0
      let checkSelect = paymentChannelsSelected[6] || false
      const payWithAdvance = valSummerySub[paymentChannelId] || null
      if (!_.isEmpty(payWithAdvance)) {
        _.map(payWithAdvance, (i: any, index: number) => {
          orderPaymentItems.push({ refItemId: props.type === 'RETROSPECTIVE' ? index + 1 : i.id, refItemType: i.type, amountPaid: i.value })
          amountPaid += i.value
          checkSelect = true
        })
      }
      if (checkSelect) newOrderPaymentChannels.push({ paymentChannelId: paymentChannelId, amountPaid: amountPaid, bankId: '', cardTypeId: '', patientTreatmentRightId: '', orderPaymentItems: orderPaymentItems })
    }


    const val = valSummery[6]
    if (val > patientFinance.advanceBalance || (val === objPayment.totalPrice && val > patientFinance.advanceBalance)) return notiError(t('PAYMENT.FORM.PLS_RENEW_ADVANCE'), undefined, undefined, () => { setDisabledButton(false) })
    // PAY
    if (props.type === 'PAYMENT') {
      const findTry = await TreatmentSummaryApi.findTreatmentSummary(props.patient.patientCase.patientCaseId).catch((res) => {
        return
      })
      if (findTry?.data?.concurrencyToken) dispatch(setConcurrencyToken(findTry.data.concurrencyToken))
      setLoading(true)
      await PaymentApi.payment(props.patient.patientCase.patientCaseId, objPay).then(async (resPay) => {
        if (resPay.status === 201) {
          if (resPay.data?.statusCode === 400) {
            setiIsCheckErrorNhsoModal(true)
            setCheckDataError(resPay.data?.message)
          } else {
            if (resPay.data?.statusCode === 404) {
              if (resPay.data?.message === 'PROMOTION_CAN_NOT_USE') {
                notiError(t('PAYMENT.MESSAGE.ERROR.PROMOTION_CAN_NOT_USE'))
              } else if (resPay.data?.message === 'VOUCHER_CAN_NOT_USE') {
                notiError(t('PAYMENT.MESSAGE.ERROR.VOUCHER_CAN_NOT_USE'))
              } else {
                notiError(t('PAYMENT.MESSAGE.ERROR.ERROR'))
              }
            } else {
              const pAlreadyTreatment: string = findTry.data.isFixCode === "1" ? localStorage.getItem('PATIENT_ALREADY_TREATMENT') || '' : ''
              const checkNewP: number[] = pAlreadyTreatment ? JSON.parse(pAlreadyTreatment) : []
              localStorage.setItem('PATIENT_ALREADY_TREATMENT', JSON.stringify(_.filter(checkNewP, (id) => id !== props.patient.patientCase.patientCaseId)))
              if (findTry.data?.summeryTreatments.length === 0) {
                if (props?.onSuccess) props.onSuccess(objPay)
                dispatch(resetStatePayment())
                window.open(`${fileUrl}/${resPay.data}`, '_blank')
                notiSuccess(t('PAYMENT.MESSAGE.SUCCESS.PAY_SUCCESS'), 'reset', null, null, 'register-page')
                history.push(routeName.payment)
              } else {
                await PatientTypeApi.getPatientTypeCheckType(props.patient?.patientCase.patientCaseId).then((resp: any) => {
                  if (resp.data?.length > 0) {
                    setIsOpenAlertModal(true)
                    setDataUrl(resPay?.data)
                    setCheckType(resp.data)
                    setObjectData(objPay)
                  } else {
                    if (props?.onSuccess) props.onSuccess(objPay)
                    dispatch(resetStatePayment())
                    window.open(`${fileUrl}/${resPay.data}`, '_blank')
                    notiSuccess(t('PAYMENT.MESSAGE.SUCCESS.PAY_SUCCESS'), 'reset', null, null, 'register-page')
                    history.push(routeName.payment)
                  }
                })
              }
            }

          }

        }

        setLoading(false)

      }).catch(async (res) => {
        const resMessage = res?.response?.data?.message || ''
        const errorPromotionVoucher = ["NOT_FOUND_VOUCHER_CODE", "VOUCHER_CAN_NOT_USE", "PROMOTION_CAN_NOT_USE", "NOT_FOUND_PROMOTION"]

        if (res?.response?.data?.message === "BRANCH_ID_NOT_MATCHED") {
          notiError(t(`ไม่สามารถชำระเงินได้ กรุณาใช้งานแค่สาขาเดียวเท่านั้น`))
          setLoading(false)
          return
        }
        if (res?.response?.data?.code === 'PROMOTION_EXCEEDS_VISIT_LIMIT') {
          const { promotionName, maxUsagePerVisit } = res.response.data
          notiError(t('PROMOTION.FORM.PROMOTION_EXCEEDS_VISIT_LIMIT', { name: promotionName, max: maxUsagePerVisit }))
          setLoading(false)
          return
        }
        if (resMessage === "PRODUCT_NOT_ENOUGH" || errorPromotionVoucher.includes(resMessage)) {
          notiError(t(`PAYMENT.MESSAGE.ERROR.${resMessage}`))
          setLoading(false)
          return
        }

        const resError = await handelCheckQueue()
        if (!resError) {
          notiError(t('PAYMENT.MESSAGE.ERROR.VISIT_DONE'))
          setLoading(false)
          return
        } else {
          notiError(t('PAYMENT.MESSAGE.ERROR.ERROR'))
        }
        // history.push(routeName.payment)
        setLoading(false)
        return
      }).finally(() => {
        setDisabledButton(false)
      })

    } else if (props.type === 'RETROSPECTIVE') {
      setDisabledButton(false)
      return props.onSuccess && props.onSuccess(objPay)
    } else if (props.type === 'EDIT_PAYMENT') {
      setLoading(true)
      PaymentApi.updateDetail(props.detail.orderPaymentId, objPay).then((resPay) => {
        setLoading(false)
        if (resPay.status === 200) {
          window.open(`${fileUrl}/${resPay.data}`, '_blank')
          notiSuccess(t('PAYMENT.MESSAGE.SUCCESS.PAY_SUCCESS'), 'reset', null, null, 'register-page')
        }
        if (props?.onSuccess) props.onSuccess()
        dispatch(resetStatePayment())
      }).catch((res) => {
        setLoading(false)
        setDisabledButton(false)
        const msg = res?.response?.data?.message
        if (msg === 'ADVANCE_REFUND_NOT_ENOUGH') {
          notiError(t('PAYMENT.MESSAGE.ERROR.ADVANCE_REFUND_NOT_ENOUGH'))
          return
        }
        notiError(t('PAYMENT.MESSAGE.ERROR.ERROR'))
      }).finally(() => {
        setDisabledButton(false)
      })
    } else {
      if (props?.orderPaymentId) {
        if (Number(objPayment.overdue + priceOutStanding) !== 0) {
          if (!newOrderPaymentChannels.length) {
            setDisabledButton(false)
            notiError(t('PAYMENT.FORM.PLS_INPUT_PAYMENT'))
          }
        }
        setLoading(true)
        OverdueApi.paidOverdue(props?.orderPaymentId, objPay).then((resPay) => {
          setDisabledButton(true)

          if (resPay.status === 201)
            notiSuccess(t(`PAYMENT.MESSAGE.SUCCESS.PAY_OVERDUE_SUCCESS`), '', null, () => {
              if (props?.onSuccess) props.onSuccess()
              window.open(`${fileUrl}/${resPay.data}`, '_blank')
              notiSuccess(t('PAYMENT.MESSAGE.SUCCESS.PAY_SUCCESS'), 'reset', null, null, 'register-page')
              dispatch(resetPaymentChannelByKey())
              dispatch(resetStatePayment())
              setDisabledButton(false)
              setLoading(false)
            })

        }).catch(async (res) => {
          setLoading(false)
          setDisabledButton(false)
          return
        }).finally(() => {
          return
        })
      }
    }
  }

  const handelCheckQueue = async () => {
    let check = false
    await PaymentApi.listQueue({ branchId: branchId }).then(({ data }) => {
      check = data.queue.some((item: any) => item.patientCaseId === props.patient.patientCase.patientCaseId)
    })

    return check
  }

  const handelCheckRank = async () => {
    const resRank = await RegisterApi.ranksCheck({ patientId: props.patient.patientId, payment: autoIncrement === 'VISIT_COUNT' ? 0 : objPayment.amountReceipt, autoIncrement: autoIncrement });
    const currentRank = _.find(memberAll, { rankId: props.patient.rankId })
    const currentIndex = _.findIndex(memberAll, { rankId: props.patient.rankId })
    const newIndex = _.findIndex(memberAll, { rankId: resRank.data.rankId })
    if (currentRank.rankId !== resRank.data.rankId) {
      if (props.patient.keyAction === '0' || (props.patient.keyAction === '1' && currentIndex < newIndex)) {
        setNewRank(resRank.data);
        setCurrentRank(currentRank);
        setIsDupicate(true);
        setDisabledButton(false)
      } else finishPayment()
    } else finishPayment()
  }

  const handelFinishPayment = async () => {
    setIsDupicate(false)
    finishPayment()
  }

  useEffect(() => {
    if (allItem) {
      // const objBalance: any = {}
      // const sumPaid: any = {}
      // _.map(arrChanel, (pcId: any) => {
      //   _.map(valSummerySub[pcId], (sub: any, index: any) => {
      //     const { value } = sub
      //     if (sumPaid[index] === undefined) sumPaid[index] = value
      //     if (index === 0 && !_.isEmpty(props?.initBalance)) {
      //       objBalance[index] -= props?.initBalance[index] || 0
      //     }
      //     sumPaid[index] += value
      //   })
      // })

      // _.map(arrChanel, (pcId: any) => {
      //   _.map(valSummerySub[pcId], (sub: any, index: any) => {
      //     const { treatmentPrice } = sub
      //     dispatch(setSummerySubByKey({ key: pcId, keySub: index, value: { ...sub, paidBalance: treatmentPrice - sumPaid[index] } }))
      //   })
      // })

      const checkSum: any = []
      const paid: any = []
      const isEditPayment = props.type === 'EDIT_PAYMENT' ? true : false

      _.map(valSummerySubTreatmentRight, (tr, i1) => {
        for (const i2 in tr) {
          if (Object.prototype.hasOwnProperty.call(tr, i2)) {
            const sub = tr[i2];
            if (sub.length) _.map(sub, (s, i3) => {
              let treatmentPrice = 0
              if (valSummerySub[i1])
                treatmentPrice = _.find(valSummerySub[i1], { id: Number(s.id), type: s.type })?.treatmentPrice || 0

              if (!checkSum[`${s.type}_${s.id}`]) checkSum[`${s.type}_${s.id}`] = { value: 0, paidBalance: 0, paymentOut: s.paymentOut, treatmentPrice: treatmentPrice }
              checkSum[`${s.type}_${s.id}`].value += s.isCheck ? s.value : 0
              checkSum[`${s.type}_${s.id}`].treatmentPrice = treatmentPrice

              if (!paid[`${i1}_${s.type}_${s.id}`]) paid[`${i1}_${s.type}_${s.id}`] = 0
              paid[`${i1}_${s.type}_${s.id}`] += (s.isCheck ? s.value : 0)

            })
          }
        }
      })
      for (const i2 in valSummerySub) {
        if (Object.prototype.hasOwnProperty.call(valSummerySub, i2)) {
          if (Number(i2) !== 5 && Number(i2) !== 7 && Number(i2) !== 8) {
            const sub = valSummerySub[i2];
            if (sub.length) _.map(sub, (s, i3) => {

              if (!checkSum[`${s.type}_${s.id}`]) checkSum[`${s.type}_${s.id}`] = { value: 0, paidBalance: 0, paymentOut: s.paymentOut, treatmentPrice: s.treatmentPrice }
              checkSum[`${s.type}_${s.id}`].value += (s.isCheck ? s.value : 0)
            })
          }
        }
      }

      _.map(valSummerySubTreatmentRight, (tr, i1) => {
        for (const i2 in tr) {
          if (Object.prototype.hasOwnProperty.call(tr, i2)) {
            const sub = tr[i2];
            _.map(sub, (s, i3) => {
              let pay = 0
              let payEdit = 0
              if ((props?.type === 'OVERDUE' || isEditPayment) && props?.histories) {

                for (const his of props.histories) {
                  pay += _.find(his.itemBalances, { refItemId: Number(s.id), refItemType: s.type })?.paid || 0
                }
                if (isEditPayment) {
                  const newEdit = _.find(props.histories, { orderPaymentId: props?.detail?.orderPaymentId });
                  payEdit = newEdit.itemPaids?.[s.type]?.[s.id] || 0
                }
              }

              const paidBalance = ((checkSum[`${s.type}_${s.id}`]?.treatmentPrice || 0) - ((checkSum[`${s.type}_${s.id}`]?.value || 0) + pay)) + payEdit
              const value = paid[`${i1}_${s.type}_${s.id}`] || 0

              dispatch(setSummerySubByKey({ key: i1, keySub: i3, value: { ...s, value: value, isCheck: isEditPayment && value ? true : s.isCheck, paidBalance: paidBalance, treatmentPrice: (checkSum[`${s.type}_${s.id}`]?.treatmentPrice || 0) } }))
              dispatch(setSummerySubTreatmentRightByKey({ key: i1, keySub: i3, patientTreatmentRightId: i2, value: { ...s, isCheck: isEditPayment && value ? true : s.isCheck, paidBalance: paidBalance, treatmentPrice: (checkSum[`${s.type}_${s.id}`]?.treatmentPrice || 0) } }))
              // }
            })
          }
        }
      })

      for (const i2 in valSummerySub) {
        if (Object.prototype.hasOwnProperty.call(valSummerySub, i2)) {
          if (Number(i2) !== 5 && Number(i2) !== 7 && Number(i2) !== 8) {
            const sub = valSummerySub[i2];
            _.map(sub, (s, i3) => {
              // if (s.isCheck) {
              let pay = 0
              let payEdit = 0
              if ((props?.type === 'OVERDUE' || isEditPayment) && props?.histories) {

                for (const his of props.histories) {
                  pay += _.find(his.itemBalances, { refItemId: Number(s.id), refItemType: s.type })?.paid || 0
                }
                if (isEditPayment) {
                  const newEdit = _.find(props.histories, { orderPaymentId: props?.detail?.orderPaymentId });
                  payEdit = newEdit.itemPaids?.[s.type]?.[s.id] || 0
                }
              }


              const paidBalance = (s.treatmentPrice - ((checkSum[`${s.type}_${s.id}`]?.value || 0) + pay)) + payEdit

              dispatch(setSummerySubByKey({ key: i2, keySub: i3, value: { ...s, paidBalance: paidBalance, } }))
              // }
            })
          }
        }
      }
    }


  }, [valSummery, allItem, valSummeryTreatmentRight])

  useEffect(() => {
    const lengthPaymentSelect = _.filter(paymentChannelsSelected, (fs) => {
      return fs === true
    }).length
    if (lengthPaymentSelect === 1) {
      const keyPaymentSelect = _.findKey(paymentChannelsSelected, (fs) => fs === true)
      const defaultPrefix = _.get(_.find(defaultPaymentChannels, { paymentChannelId: Number(keyPaymentSelect) }), 'defaultPrefix')
      if (defaultPrefix) dispatch(setPaymentByKey({ key: 'prefix', value: defaultPrefix }))
    } else return
  }, [paymentChannelsSelected])

  function toPascalCase(str: string): string {
    return str
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }

  return (
    <UseStyled.ModalStyle size={'xl'} show={props.isShow} centered fullscreen>
      <AlertModal
        isOpen={isOpenAlertModal}
        title='ยืนยันการเพิ่มประเภทผู้ป่วย'
        message='เพิ่มประเภทผู้ป่วย ผู้ป่วยอุดฟัน(ผู้ป่วยอุดฟัน) เนื่องจากตรงตามเงื่อนไข'
        type='success'
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{
          onClick: () => {
            setIsOpenAlertModal(false)
            if (props?.onSuccess) props.onSuccess(objectData)
            dispatch(resetStatePayment())
            window.open(`${fileUrl}/${dataUrl}`, '_blank')
            notiSuccess(t('PAYMENT.MESSAGE.SUCCESS.PAY_SUCCESS'), 'reset', null, null, 'register-page')
            history.push(routeName.payment)
          }, title: 'ตกลง'
        }}
        onSubmit={{ onClick: () => null }}
        onCloseSubmit
      >
        <Box>
          <Typography fontSize="14px" fontWeight={600} marginTop="16px">ประเภทผู้ป่วย</Typography>
          {_.map(checkType, (item) => {
            return (
              <Box marginTop="16px" key={item.itemId}>
                <Typography fontSize="14px" fontWeight={400}>{item?.patientTypeName}</Typography>
                <Typography fontSize="14px" fontWeight={400} paddingLeft="16px"> • {item?.itemName}</Typography>
              </Box>
            );
          })}
        </Box>
      </AlertModal>
      <AlertModal
        isOpen={isNhsoSaveMedicalModal}
        handleClose={() => setIsNhsoSaveMedicalModal(false)}
        onCancel={{ onClick: () => setIsNhsoSaveMedicalModal(false) }}
        onSubmit={{
          onClick: () => {
            setIsNhsoSaveMedicalModal(false)
            setDisabledButton(true)
            payment()
          }
        }}
        title='ยืนยันการส่งเบิก'
        message={'ระบบตรวจสอบรูปแบบการส่งถูกต้อง\nคุณยืนยันส่งเบิกการใช้สิทธิสปสช.ใน visit นี้ ใช่หรือไม่'}
        type='success'
      >
      </AlertModal>
      <AlertModal
        isOpen={isCheckErrorNhsoModal}
        title='ไม่สามารถส่งเบิก'
        message={`ระบบไม่สามารถส่งเบิกการใช้สิทธิสปสช.เนื่องจากรูปแบบไม่ถูกต้อง\nคุณต้องแก้ไขรูปแบบให้ถูกต้องหรือเปิด visit ทั่วไปเพื่อดำเนินการชำระเงิน\nโดยไม่ใช้สิทธิสปสช.`}
        type='error'
        handleClose={() => setiIsCheckErrorNhsoModal(false)}
        onCancel={{ onClick: () => setiIsCheckErrorNhsoModal(false), title: 'ตกลง' }}
        onSubmit={{ onClick: () => null }}
        onCloseSubmit
      >
        <Box>
          <Box display="flex" flexDirection="row" alignItems="center" gap="8px" paddingY="16px">
            <CancelIcon style={{ color: 'red' }} />
            <Typography fontSize="14px" fontWeight={600}>หมายเหตุข้อผิดพลาด</Typography>
          </Box>

          {_.map(checkDataError, (item) => (
            <Box display="flex" flexDirection="row" alignItems="center">
              <Typography>• {item?.statusCode} = {toPascalCase(item?.statusDesc)}</Typography>
            </Box>
          ))}
        </Box>
      </AlertModal>
      <Modal.Body className="py-0 overflow-hidden">
        <Loading show={loading} type="fullLoading" />
        <Grid container spacing={2} className="my-0 h-100 pb-4">
          <Grid lg={6} item className={`w-100 h-100 ${activePage === 0 ? 'd-block' : 'd-none'} d-xl-block`}>
            <Box className="pr-xl-3 h-100 d-flex flex-column">
              <Typography className="pb-4 text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                {t('PAYMENT.FORM_PAYMENT.TITLE.PAYMENT_DETAIL')}
              </Typography>
              <Box className="custom-scroll" sx={{ overflowX: 'auto' }}>
                <Info patient={props.patient} finance={{ advanceBalance: patientFinance.advanceBalance, outstandingBalance: patientFinance.outstandingBalance }} treatmentRights={patientFinance.treatmentRights} />
                <PaymentChannels
                  menu={props.type}
                  treatments={props.type === "EDIT_PAYMENT" ? props.detail : treatments}
                  banks={banks}
                  balancePaid={objPayment.totalPrice}
                  overdue={objPayment.overdue + priceOutStanding}
                  patientFinance={patientFinance.treatmentRights}
                  patientFinanceFull={patientFinance}
                  promotionPayment={promotionPayment}
                  voucherPayment={voucherPayment}
                  patientCaseId={props.patientCaseId || props?.patient?.patientCase?.patientCaseId || props?.detail?.order?.patientCaseId}
                  patientId={props.patient?.patientId}
                  date={props.date}
                  dataPatientCase={props.dataPatientCase}
                />
                {checkDataError.length > 0 && <Box border={1} borderColor="#C5C5C5" margin="16px" padding="16px">
                  <Box display="flex" flexDirection="row" alignItems="center" gap="8px" paddingY="16px">
                    <CancelIcon style={{ color: 'red' }} />
                    <Typography fontSize="14px" fontWeight={600}>หมายเหตุข้อผิดพลาด</Typography>
                  </Box>
                  {_.map(checkDataError, (item) => (
                    <Box display="flex" flexDirection="row" alignItems="center" paddingY='8px'>
                      <Typography>• {item?.statusCode} = {toPascalCase(item?.statusDesc)}</Typography>
                    </Box>
                  ))}
                </Box>}
              </Box>
              <UseStyled.FooterStepButton className="d-flex d-xl-none justify-content-md-end mt-2 mr-md-2">
                <ButtonCustom textButton={t('BUTTON.CANCEL')} variant="outlined" onClick={() => props.setIsShow(false)} />
                <ButtonCustom textButton={t('BUTTON.NEXT')} disabled={loading || disabledNext}
                  onClick={() => {
                    setDisabledNext(true)
                    alertTreantRights()
                  }}
                />
              </UseStyled.FooterStepButton>
            </Box>
          </Grid>
          <Grid lg={6} item className={`w-100 h-100 ${activePage === 1 ? 'd-block' : 'd-none'} d-xl-block`} sx={{ borderLeft: { lg: `1px solid ${colors.lightGray}` } }}>
            <Box className="h-100 d-flex flex-column">
              <Typography className="pb-4 text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                {t('PAYMENT.FORM_PAYMENT.TITLE.PAYMENT_SUMMARY')}
              </Typography>
              <Box className="custom-scroll mb-3" sx={{ overflowX: 'auto' }}>
                <UseStyled.SummaryNetPrice className="d-flex align-items-center mx-md-3 mx-xl-4 mb-3">
                  <Box className="d-flex align-items-center justify-content-center flex-column h-100">
                    <Typography className="text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                      {props.type === "EDIT_PAYMENT" ? numberFormat(props.detail.totalPrice) : numberFormat(objPayment.totalPrice + priceOutStanding)} {t('CURRENCY_CHANGE.TH')}
                    </Typography>
                    <Typography className="text-center" sx={{ fontSize: 14, color: colors.themeMainColor }}>
                      {t('PAYMENT.FORM_PAYMENT.NET_PRICE')}
                    </Typography>
                  </Box>
                  <Box className="d-flex align-items-center justify-content-center flex-column h-100" sx={{ borderLeft: `1px solid ${colors.lightGray}` }}>
                    <Typography className="text-center" sx={{ fontSize: 20, color: colors.themeMainColor, fontWeight: 600 }}>
                      {numberFormat(objPayment.overdue + priceOutStanding)} {t('CURRENCY_CHANGE.TH')}
                    </Typography>
                    <Typography className="text-center" sx={{ fontSize: 14, color: colors.themeMainColor }}>
                      {t('PAYMENT.FORM_PAYMENT.OUT_STANDING_PRICE')}
                    </Typography>
                  </Box>
                </UseStyled.SummaryNetPrice>
                <Box className="d-flex align-items-center px-md-2 px-xl-3 mb-3">
                  <Typography sx={{ fontSize: 18, fontWeight: 500 }}>{t('PAYMENT.FORM_PAYMENT.RECEIPT_TYPE')}</Typography>
                  <Box className="d-flex align-items-center justify-content-end pl-2" sx={{ flex: 1 }}>
                    <Box className="w-100" sx={{ maxWidth: '112px' }}>

                      <BasicSelect
                        disabled={Config.IS_TDH === '1' && props.type === 'EDIT_PAYMENT'}
                        selectId=""
                        label=""
                        labelId="billPrefixId"
                        onchange={(e: any) => dispatch(setPaymentByKey({ key: 'prefix', value: e.target.value }))}
                        value={objPayment.prefix}
                        options={_.map(billPrefixes, (i: any) => (
                          <MenuItem key={i.billPrefixId || i.paymentChannelId} value={i.prefix || i.defaultPrefix}>
                            {i.prefix || i.defaultPrefix}
                          </MenuItem>
                        ))}
                      />
                    </Box>
                    <Typography className="pl-3 d-none d-sm-block" sx={{ flex: 'none' }}>
                      {props.type !== 'RETROSPECTIVE' ? '-xxx-xx-xx-xxxxx' : '-xx-xx-xxxxx'}
                    </Typography>
                  </Box>
                </Box>
                <SummaryReceipt treatments={props.type === "EDIT_PAYMENT" ? props.detail : treatments} initBalance={props.initBalance} patient={props.patient} date={props.date} />
                <Box className="px-md-2 px-xl-3 mb-md-3 pt-md-2">
                  <InputTextarea
                    key={'important-symptoms'}
                    onchange={(e: any) => {
                      dispatch(setPaymentByKey({ key: 'remark', value: e.target.value }))
                    }}
                    value={objPayment.remark}
                    label={t('PAYMENT.FORM_PAYMENT.REMARK')}
                  />
                </Box>
                <Box className="px-md-2 px-xl-3 mb-md-3 pt-md-2">
                  {props.histories?.length && (
                    <>
                      {_.map(props.histories, (his: any, iHis: number) => {
                        return <p className="mb-1">{`${t('PAYMENT.PAY')} #${iHis + 1} ${dateTimeToView(his.createdAt)} (${numberToCurrencyFormat(his.amountItemPaid)})`}</p>
                      })}
                    </>
                  )}
                </Box>
              </Box>
              <UseStyled.FooterPaymentButton className="d-flex flex-column mt-auto">
                <ButtonCustom textButton={t('PAYMENT.FORM_PAYMENT.BUTTON_BACK_TO_DETAIL')} variant="outlined" onClick={() => {
                  setActivePage(0)
                  setDisabledNext(false)
                }} className="d-xl-none" />
                <ButtonCustom
                  textButton={t('BUTTON.CANCEL')}
                  variant="outlined"
                  onClick={() => {
                    props.setIsShow(false)
                    dispatch(resetStatePayment())
                  }}
                  className="d-none d-xl-block"
                />
                <ButtonCustom
                  textButton={t('PAYMENT.FORM_PAYMENT.BUTTON_PAYMENT')}
                  disabled={loading || disabledButton}
                  onClick={() => {
                    if (props.dataPatientCase?.isNhso === '1') {
                      setIsNhsoSaveMedicalModal(true)
                    } else {
                      setDisabledButton(true)
                      payment()
                    }
                  }}
                  className="mt-2 mt-md-3"
                />
              </UseStyled.FooterPaymentButton>
            </Box>
          </Grid>
        </Grid>
      </Modal.Body>
      <Box>
        <AlertModal
          isOpen={isDupicate}
          title={t('RANK.CONFIRM_MEMBER_RANK_CHANGE')}
          message={t('RANK.PATIENT_RANK_CHANGE_NOTIFICATION', { newRankName: newRank.rankName })}
          type="success"
          onSubmit={{ onClick: () => null }}
          onCancel={{ onClick: () => handelFinishPayment(), title: t('BUTTON.ENTER') }}
          onCloseSubmit
          handleClose={() => setIsDupicate(false)}
        >
          <Box sx={{ pt: 3, textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <Typography variant="body1" sx={{ pb: 2, fontWeight: 'bold' }}>{t('RANK.PREVIOUS_MEMBER_RANK')}</Typography>
            <Typography variant="body2">{currentRank.rankName}</Typography>
            <List sx={{ pl: 2 }}>
              <ListItem disablePadding>
                <Box sx={{ width: '5px', height: '5px', backgroundColor: colors.gray, display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '5px', marginTop: '3px', borderRadius: '50px' }}></Box>
                <Typography variant="body2">{autoIncrement !== 'NO_SETTING' ? autoIncrement !== 'VISIT_COUNT' ? t('RANK.TOTAL_SPENDING_SINCE', { total: currentRank.totalPaid }) : t('RANK.VISIT_COUNT_SINCE', { total: currentRank.serviceVisits }) : <></>}</Typography>
              </ListItem>
              {/* <ListItem disablePadding>
                <Box sx={{ width: '5px', height: '5px', backgroundColor: colors.gray, display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '5px', marginTop: '3px', borderRadius: '50px' }}></Box>
                <Typography variant="body2">{t('RANK.VISIT_COUNT_SINCE', { total: currentRank.serviceVisits })}</Typography>
              </ListItem> */}
            </List>
            <Typography variant="body1" sx={{ pb: 2, fontWeight: 'bold' }}>{t('RANK.NEW_MEMBER_RANK')}</Typography>
            <Typography variant="body2">{newRank.rankName}</Typography>
            <List sx={{ pl: 2 }}>
              <ListItem disablePadding>
                <Box sx={{ width: '5px', height: '5px', backgroundColor: colors.gray, display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '5px', marginTop: '3px', borderRadius: '50px' }}></Box>
                <Typography variant="body2">{autoIncrement !== 'NO_SETTING' ? autoIncrement !== 'VISIT_COUNT' ? t('RANK.NEW_TOTAL_SPENDING', { newTotal: newRank.totalPaid }) : t('RANK.NEW_VISIT_COUNT', { newTotal: newRank.serviceVisits }) : <></>}</Typography>
              </ListItem>
              {/* <ListItem disablePadding>
                <Box sx={{ width: '5px', height: '5px', backgroundColor: colors.gray, display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '5px', marginTop: '3px', borderRadius: '50px' }}></Box>
                <Typography variant="body2">{t('RANK.NEW_VISIT_COUNT', { newTotal: newRank.serviceVisits })}</Typography>
              </ListItem> */}
            </List>
          </Box>
        </AlertModal>
      </Box>
    </UseStyled.ModalStyle>
  )

}
